/* eslint-disable react/no-array-index-key */
import React, { Component, useEffect, useRef, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import ReactDOM from "react-dom";
import { Nav, NavItem, Collapse } from "reactstrap";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import classnames from "classnames";
import PerfectScrollbar from "react-perfect-scrollbar";

import IntlMessages from "/@src/helpers/IntlMessages";

import {
  setContainerClassnames,
  addContainerClassname,
  changeDefaultClassnames,
  changeSelectedMenuHasSubItems,
} from "/@src/redux/actions";

import menuItems from "/@src/constants/menu";
import { Can } from "/@src/components/Can";

const Sidebar = () => {
  const [selectedParentMenu, setSelectedParentMenu] = useState("");
  const [viewingParentMenu, setViewingParentMenu] = useState("");
  const [collapsedMenus, setCollapsedMenus] = useState([]);
  const {
    containerClassnames,
    menuHiddenBreakpoint,
    subHiddenBreakpoint,
    menuClickCount,
    selectedMenuHasSubItems,
  } = useSelector(({ menu }) => menu);
  const dispatch = useDispatch();

  const containerRef = useRef(null);
  // eslint-disable-next-line react/sort-comp
  const handleWindowResize = (event) => {
    if (event && !event.isTrusted) {
      return;
    }
    const nextClasses = getMenuClassesForResize(containerClassnames);
    dispatch(
      setContainerClassnames(0, nextClasses.join(" "), selectedMenuHasSubItems)
    );
  };

  const handleDocumentClick = (e) => {
    const container = getContainer();
    let isMenuClick = false;
    if (
      e.target &&
      e.target.classList &&
      (e.target.classList.contains("menu-button") ||
        e.target.classList.contains("menu-button-mobile"))
    ) {
      isMenuClick = true;
    } else if (
      e.target.parentElement &&
      e.target.parentElement.classList &&
      (e.target.parentElement.classList.contains("menu-button") ||
        e.target.parentElement.classList.contains("menu-button-mobile"))
    ) {
      isMenuClick = true;
    } else if (
      e.target.parentElement &&
      e.target.parentElement.parentElement &&
      e.target.parentElement.parentElement.classList &&
      (e.target.parentElement.parentElement.classList.contains("menu-button") ||
        e.target.parentElement.parentElement.classList.contains(
          "menu-button-mobile"
        ))
    ) {
      isMenuClick = true;
    }
    if (container.contains(e.target) || container === e.target || isMenuClick) {
      return;
    }
    setViewingParentMenu("");
    toggle();
  };

  const getMenuClassesForResize = (classes) => {
    let nextClasses = classes.split(" ").filter((x) => x !== "");
    const windowWidth = window.innerWidth;
    if (windowWidth < menuHiddenBreakpoint) {
      nextClasses.push("menu-mobile");
    } else if (windowWidth < subHiddenBreakpoint) {
      nextClasses = nextClasses.filter((x) => x !== "menu-mobile");
      if (
        nextClasses.includes("menu-default") &&
        !nextClasses.includes("menu-sub-hidden")
      ) {
        nextClasses.push("menu-sub-hidden");
      }
    } else {
      nextClasses = nextClasses.filter((x) => x !== "menu-mobile");
      if (
        nextClasses.includes("menu-default") &&
        nextClasses.includes("menu-sub-hidden")
      ) {
        nextClasses = nextClasses.filter((x) => x !== "menu-sub-hidden");
      }
    }
    return nextClasses;
  };

  const getContainer = () => {
    // eslint-disable-next-line react/no-find-dom-node
    // return ReactDOM.findDOMNode(this);
    return containerRef.current;
  };

  const toggle = () => {
    const hasSubItems = getIsHasSubItem();
    // eslint-disable-next-line react/destructuring-assignment
    dispatch(changeSelectedMenuHasSubItems(hasSubItems));
    const currentClasses = containerClassnames
      ? containerClassnames.split(" ").filter((x) => x !== "")
      : "";
    let clickIndex = -1;

    if (!hasSubItems) {
      if (
        currentClasses.includes("menu-default") &&
        (menuClickCount % 4 === 0 || menuClickCount % 4 === 3)
      ) {
        clickIndex = 1;
      } else if (
        currentClasses.includes("menu-sub-hidden") &&
        (menuClickCount === 2 || menuClickCount === 3)
      ) {
        clickIndex = 0;
      } else if (
        currentClasses.includes("menu-hidden") ||
        currentClasses.includes("menu-mobile")
      ) {
        clickIndex = 0;
      }
    } else if (
      currentClasses.includes("menu-sub-hidden") &&
      menuClickCount === 3
    ) {
      clickIndex = 2;
    } else if (
      currentClasses.includes("menu-hidden") ||
      currentClasses.includes("menu-mobile")
    ) {
      clickIndex = 0;
    }
    if (clickIndex >= 0) {
      // eslint-disable-next-line react/destructuring-assignment
      dispatch(
        setContainerClassnames(clickIndex, containerClassnames, hasSubItems)
      );
    }
  };

  const handleProps = () => {
    addEvents();
  };

  const addEvents = () => {
    ["click", "touchstart", "touchend"].forEach((event) =>
      document.addEventListener(event, handleDocumentClick, true)
    );
  };

  const removeEvents = () => {
    ["click", "touchstart", "touchend"].forEach((event) =>
      document.removeEventListener(event, handleDocumentClick, true)
    );
  };

  const setSelectedLiActive = () => {
    const oldli = document.querySelector(".sub-menu  li.active");
    if (oldli != null) {
      oldli.classList.remove("active");
    }

    const oldliSub = document.querySelector(".third-level-menu  li.active");
    if (oldliSub != null) {
      oldliSub.classList.remove("active");
    }

    /* set selected parent menu */
    const selectedSublink = document.querySelector(
      ".third-level-menu  a.active"
    );
    if (selectedSublink != null) {
      selectedSublink.parentElement.classList.add("active");
    }

    const selectedlink = document.querySelector(".sub-menu  a.active");
    if (selectedlink != null) {
      selectedlink.parentElement.classList.add("active");
      setSelectedParentMenu(
        selectedlink.parentElement.parentElement.getAttribute("data-parent")
      );
    } else {
      const selectedParentNoSubItem = document.querySelector(
        ".main-menu  li a.active"
      );
      if (selectedParentNoSubItem != null) {
        setSelectedParentMenu(
          selectedParentNoSubItem.getAttribute("data-flag")
        );
        // eslint-disable-next-line react/destructuring-assignment
      } else if (selectedParentMenu === "") {
        setSelectedParentMenu(menuItems[0].id);
      }
    }
  };

  const setHasSubItemStatus = () => {
    const hasSubmenu = getIsHasSubItem();
    // eslint-disable-next-line react/destructuring-assignment
    dispatch(changeSelectedMenuHasSubItems(hasSubmenu));
    toggle();
  };

  const getIsHasSubItem = () => {
    const menuItem = menuItems.find((x) => x.id === selectedParentMenu);
    if (menuItem)
      return !!(menuItem && menuItem.subs && menuItem.subs.length > 0);
    return false;
  };

  useEffect(() => {
    setHasSubItemStatus();
  }, [selectedParentMenu]);

  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    handleWindowResize();
    handleProps();
    setSelectedLiActive(setHasSubItemStatus);
    return () => {
      removeEvents();
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  const toggleMenuCollapse = (e, menuKey) => {
    e.preventDefault();

    if (collapsedMenus.indexOf(menuKey) > -1) {
      setCollapsedMenus(collapsedMenus.filter((x) => x !== menuKey));
    } else {
      collapsedMenus.push(menuKey);
      setCollapsedMenus(collapsedMenus);
    }
    return false;
  };

  const openSubMenu = (e, menuItem) => {
    const selectedParent = menuItem.id;
    const hasSubMenu = menuItem.subs && menuItem.subs.length > 0;
    // eslint-disable-next-line react/destructuring-assignment
    changeSelectedMenuHasSubItems(hasSubMenu);
    if (!hasSubMenu) {
      setViewingParentMenu(selectedParent);
      setSelectedParentMenu(selectedParent);
      toggle();
    } else {
      e.preventDefault();

      const currentClasses = containerClassnames
        ? containerClassnames.split(" ").filter((x) => x !== "")
        : "";

      if (!currentClasses.includes("menu-mobile")) {
        if (
          currentClasses.includes("menu-sub-hidden") &&
          (menuClickCount === 2 || menuClickCount === 0)
        ) {
          // eslint-disable-next-line react/destructuring-assignment
          setContainerClassnames(3, containerClassnames, hasSubMenu);
        } else if (
          currentClasses.includes("menu-hidden") &&
          (menuClickCount === 1 || menuClickCount === 3)
        ) {
          // eslint-disable-next-line react/destructuring-assignment
          setContainerClassnames(2, containerClassnames, hasSubMenu);
        } else if (
          currentClasses.includes("menu-default") &&
          !currentClasses.includes("menu-sub-hidden") &&
          (menuClickCount === 1 || menuClickCount === 3)
        ) {
          // eslint-disable-next-line react/destructuring-assignment
          setContainerClassnames(0, containerClassnames, hasSubMenu);
        }
      } else {
        // eslint-disable-next-line react/destructuring-assignment
        addContainerClassname("sub-show-temporary", containerClassnames);
      }
      setViewingParentMenu(selectedParent);
    }
  };

  return (
    <div className="sidebar" ref={containerRef}>
      <div className="main-menu">
        <div className="scroll">
          <PerfectScrollbar
            options={{ suppressScrollX: true, wheelPropagation: false }}
          >
            <Nav vertical className="list-unstyled">
              {menuItems &&
                menuItems.map((item, id) => {
                  const nav = (
                    <NavItem
                      key={id}
                      className={classnames({
                        active:
                          (selectedParentMenu === item.id &&
                            viewingParentMenu === "") ||
                          viewingParentMenu === item.id,
                      })}
                    >
                      {item.newWindow ? (
                        <a
                          href={item.to}
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          <i className={item.icon} />{" "}
                          <IntlMessages id={item.label} />
                        </a>
                      ) : (
                        <NavLink
                          to={item.to}
                          onClick={(e) => openSubMenu(e, item)}
                          data-flag={item.id}
                        >
                          <i className={item.icon} />{" "}
                          <IntlMessages id={item.label} />
                        </NavLink>
                      )}
                    </NavItem>
                  );
                  if (item.permission) {
                    const { action, subject } = item.permission;
                    return (
                      <Can key={id} I={action} this={subject}>
                      {() => nav}
                      </Can>
                    );
                  }
                  return nav;
                })}
            </Nav>
          </PerfectScrollbar>
        </div>
      </div>

      <div className="sub-menu">
        <div className="scroll">
          <PerfectScrollbar
            options={{ suppressScrollX: true, wheelPropagation: false }}
          >
            {menuItems &&
              menuItems.map((item) => {
                return (
                  <Nav
                    key={item.id}
                    className={classnames({
                      "d-block":
                        // eslint-disable-next-line react/destructuring-assignment
                        (selectedParentMenu === item.id &&
                          // eslint-disable-next-line react/destructuring-assignment
                          viewingParentMenu === "") ||
                        // eslint-disable-next-line react/destructuring-assignment
                        viewingParentMenu === item.id,
                    })}
                    data-parent={item.id}
                  >
                    {item.subs &&
                      item.subs.map((sub, index) => {
                        const nav = (
                          <NavItem
                            key={`${item.id}_${index}`}
                            className={`${
                              sub.subs && sub.subs.length > 0
                                ? "has-sub-item"
                                : ""
                            }`}
                          >
                            {/* eslint-disable-next-line no-nested-ternary */}
                            {sub.newWindow ? (
                              <a
                                href={sub.to}
                                rel="noopener noreferrer"
                                target="_blank"
                              >
                                <i className={sub.icon} />{" "}
                                <IntlMessages id={sub.label} />
                              </a>
                            ) : sub.subs && sub.subs.length > 0 ? (
                              <>
                                <NavLink
                                  className={`rotate-arrow-icon opacity-50 ${
                                    collapsedMenus.indexOf(
                                      `${item.id}_${index}`
                                    ) === -1
                                      ? ""
                                      : "collapsed"
                                  }`}
                                  to={sub.to}
                                  id={`${item.id}_${index}`}
                                  onClick={(e) =>
                                    toggleMenuCollapse(e, `${item.id}_${index}`)
                                  }
                                >
                                  <i className="simple-icon-arrow-down" />{" "}
                                  <IntlMessages id={sub.label} />
                                </NavLink>

                                <Collapse
                                  isOpen={
                                    collapsedMenus.indexOf(
                                      `${item.id}_${index}`
                                    ) === -1
                                  }
                                >
                                  <Nav className="third-level-menu">
                                    {sub.subs.map((thirdSub, thirdIndex) => {
                                      return (
                                        <NavItem
                                          key={`${item.id}_${index}_${thirdIndex}`}
                                        >
                                          {thirdSub.newWindow ? (
                                            <a
                                              href={thirdSub.to}
                                              rel="noopener noreferrer"
                                              target="_blank"
                                            >
                                              <i className={thirdSub.icon} />{" "}
                                              <IntlMessages
                                                id={thirdSub.label}
                                              />
                                            </a>
                                          ) : (
                                            <NavLink to={thirdSub.to}>
                                              <i className={thirdSub.icon} />{" "}
                                              <IntlMessages
                                                id={thirdSub.label}
                                              />
                                            </NavLink>
                                          )}
                                        </NavItem>
                                      );
                                    })}
                                  </Nav>
                                </Collapse>
                              </>
                            ) : (
                              <NavLink to={sub.to}>
                                <i className={sub.icon} />{" "}
                                <IntlMessages id={sub.label} />
                              </NavLink>
                            )}
                          </NavItem>
                        );
                        if (item.permission) {
                          const { action, subject } = item.permission;
                          return (
                            <Can I={action} this={subject}>
                            {() => nav}
                            </Can>
                          );
                        }
                        return nav;
                      })}
                  </Nav>
                );
              })}
          </PerfectScrollbar>
        </div>
      </div>
    </div>
  );
};

// const mapStateToProps = ({ menu, authUser }) => {
//   const {
//     containerClassnames,
//     subHiddenBreakpoint,
//     menuHiddenBreakpoint,
//     menuClickCount,
//     selectedMenuHasSubItems,
//   } = menu;

//   const { currentUser } = authUser;
//   return {
//     containerClassnames,
//     subHiddenBreakpoint,
//     menuHiddenBreakpoint,
//     menuClickCount,
//     selectedMenuHasSubItems,
//     currentUser,
//   };
// };
// export default withRouter(
//   connect(mapStateToProps, {
//     setContainerClassnames,
//     addContainerClassname,
//     changeDefaultClassnames,
//     changeSelectedMenuHasSubItems,
//   })(Sidebar)
// );

export default Sidebar;
